import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const HeaderServicios = ({servicio,entregaId=""}) => {
  const navigate = useNavigate();

  const handleRegresar = () => {
      navigate(-1);
  };

  const handleRegresarServicio = () =>{
    navigate(`/contabilidad/detalles_servicio/${servicio.nombreEmpresa}/${servicio.codigo}`);
  }

  // Función para calcular días restantes
  const calcularDiasRestantes = (fechaEntrega) => {
    // Verifica si la fecha viene en formato string
    if (!fechaEntrega) return 0;
    
    // Convierte a objeto Date si es string
    const fechaEntregaOriginal = fechaEntrega instanceof Date 
      ? fechaEntrega 
      : new Date(fechaEntrega);
    
    // Crear copias de las fechas para no modificar la original
    const fechaEntregaDate = new Date(fechaEntregaOriginal.getTime());
    const hoy = new Date();
    
    // Establecer horas a 0 en las copias
    fechaEntregaDate.setHours(0, 0, 0, 0);
    hoy.setHours(0, 0, 0, 0);
    
    // Calcular diferencia en milisegundos
    const diferenciaMs = fechaEntregaDate - hoy;
    
    // Convertir a días
    const diasRestantes = Math.ceil(diferenciaMs / (1000 * 60 * 60 * 24));
    
    return diasRestantes;
  };

  //entrega especifica seleccionada
  const entregaEspecifica = useMemo(() => {
    if (!entregaId || !Array.isArray(servicio?.entregasTrabajo)) {
      return null;
    }
    return servicio.entregasTrabajo.find(e => e.id === entregaId);
  }, [servicio?.entregasTrabajo, entregaId]);

  //calcular si se entrogo o no 
  //variables
  const tituloPrincipal = entregaEspecifica 
    ? `${entregaEspecifica.id} - ${entregaEspecifica.motivo}` 
    : servicio.materia;
  const fechaParaCalcular = entregaEspecifica 
    ? entregaEspecifica.fechaentrega 
    : servicio?.fechaentrega;
  const estaCompletado = entregaEspecifica 
    ? false 
    : servicio.getTrabajoEntregado();

  return (
    <div className="relative bg-white shadow-xl rounded-b-3xl overflow-hidden mb-8">
      {/* Fondo con gradiente y patrón */}
      <div className="relative bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700">
        {/* Patrón decorativo de fondo */}
        <div className="absolute inset-0 opacity-10">
                <svg className="w-full h-full" viewBox="0 0 100 100">
                  <defs>
                    <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
                      <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" strokeWidth="0.5"/>
                    </pattern>
                  </defs>
                  <rect width="100" height="100" fill="url(#grid)" />
                </svg>
        </div>
              
        {/* Barra superior con efecto brillante */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-white to-transparent opacity-30"></div>
              
          {/* Contenido del header */}
          <div className="relative px-6 py-8">
                {/* Botón volver mejorado */}
                <div className="mb-6">
                  <button 
                    onClick={handleRegresar} 
                    className="group flex items-center text-blue-100 hover:text-white transition-all duration-200 bg-white bg-opacity-10 hover:bg-opacity-20 px-4 py-2 rounded-xl backdrop-blur-sm"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 group-hover:-translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    <span className="text-sm font-medium">Volver</span>
                  </button>
                </div>

                {/* Volver a servicio original */}
                {entregaId != "" && (
                  <div className="mb-6">
                  <button 
                    onClick={handleRegresarServicio} 
                    className="group flex items-center text-blue-100 hover:text-white transition-all duration-200 bg-white bg-opacity-10 hover:bg-opacity-20 px-4 py-2 rounded-xl backdrop-blur-sm"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 group-hover:-translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    <span className="text-sm font-medium">Ir a servicio principal</span>
                  </button>
                  </div>
                )}
                

                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                  {/* Información principal */}
                  <div className="flex items-start gap-4">
                    {/* Icono principal mejorado */}
                    <div className="bg-white bg-opacity-15 backdrop-blur-sm p-4 rounded-2xl shadow-lg">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    
                    <div className="space-y-1">
                      <p className="text-blue-100 text-sm font-medium tracking-wide uppercase">Entrega de actividad</p>
                      <h1 className="text-white text-3xl font-bold tracking-tight">
                        {tituloPrincipal}
                      </h1>
                      <p className="text-blue-200 text-sm">
                        {servicio.nombreEmpresa}
                      </p>
                    </div>
                  </div>

                  {/* Panel de estado mejorado */}
                  <div className="bg-white bg-opacity-95 backdrop-blur-sm rounded-2xl p-6 shadow-2xl border border-white border-opacity-20 min-w-[280px]">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Estado del Servicio</h3>
                      <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                    </div>
                    
                    {estaCompletado ? (
                      /* Trabajo entregado */
                      <div className="flex items-center gap-4">
                        <div className="bg-gradient-to-r from-green-500 to-emerald-500 p-3 rounded-xl shadow-lg">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-green-700 font-bold text-lg">Completado</p>
                          <p className="text-gray-600 text-sm">Trabajo entregado exitosamente</p>
                        </div>
                      </div>
                    ) : calcularDiasRestantes(fechaParaCalcular) < 0 ? (
                      /* Trabajo atrasado */
                      <div className="flex items-center gap-4">
                        <div className="bg-gradient-to-r from-red-500 to-rose-500 p-3 rounded-xl shadow-lg">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-red-700 font-bold text-lg">ATRASADO</p>
                          <p className="text-gray-600 text-sm">Requiere atención inmediata</p>
                        </div>
                      </div>
                    ) : (
                      /* Tiempo restante normal */
                      <div className="flex items-center gap-4">
                        <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-3 rounded-xl shadow-lg">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-amber-700 font-bold text-lg">
                            {calcularDiasRestantes(servicio?.fechaentrega) === 0
                              ? 'Entrega hoy'
                              : `${calcularDiasRestantes(servicio?.fechaentrega)} días`}
                          </p>
                          <p className="text-gray-600 text-sm">Tiempo restante</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
          </div>
              
          {/* Onda decorativa inferior */}
          <div className="absolute bottom-0 left-0 w-full overflow-hidden">
                <svg className="relative block w-full h-4" viewBox="0 0 1200 120" preserveAspectRatio="none">
                  <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" 
                        fill="rgba(255,255,255,0.1)"></path>
                </svg>
          </div>
      </div>
    </div>
  )
}

export default HeaderServicios
